import React,{useEffect} from "react";
// ,useState,useContext
//import { CopyToClipboard } from 'react-copy-to-clipboard';
import "./style.css";

import { Modal, Button } from 'react-bootstrap';

function ConfirmLeaveChatModal (props) {

  function onLeave() {
    console.log("ConfirmLeaveChatModal onLeave");
    if (props.onLeave) {
      props.onHide();
      props.onLeave();
    }
  }
  
  function transferOwnership() {
    console.log("transferOwnership");
    if (props.transferOwnership) {
      props.onHide();
      props.transferOwnership();
    }
  }
  
  // on mount
  useEffect(() => {
    console.log("ConfirmLeaveChatModal useEffect props.show",props.streamList);
    
    if (props.streamList.length > 1) {
      
    }

    /*
    if (!context.user_info) {
      return;
    }
    
    setupForm();
    
    const fetchData = async () => {
      //console.log("OnBoardingModal fetching locations");
    };
    */
    //fetchData();
  }, [props.show]);

  
    return (
      <Modal
        style={{ color: 'black' }}
        show={props.show}
        onHide={props.onHide}
        //{...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          End PechaKucha Video Chat Session?
        </Modal.Header>
        <Modal.Body>
          You are the chat owner - leaving will permanently end this video chat session for all participants and invitees.<br/>
          { props.streamList.length > 1 &&
            <span>If you wish to keep the chat active, please transfer ownership to another participant before leaving.</span>
          }
        </Modal.Body>
        <Modal.Footer>
          { props.streamList.length > 1 &&
            <Button
              className="modal_button_white"
              onClick={() => transferOwnership()}
            >
              Transfer Ownership
            </Button>
          }
          <Button
            className="modal_button_white"
            onClick={props.onHide}
          >
            Don't Leave!
          </Button>
          <Button
            className="modal_button_red"
            //variant="danger"
            onClick={() => onLeave()}
            //disabled={loading}
          >
            Leave and End Chat Session
          </Button>
        </Modal.Footer>
      </Modal>
    );

}

export default ConfirmLeaveChatModal;
